var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1562 27.5938H13.8437C10.4375 27.5938 7.6875 30.3437 7.6875 33.75C7.6875 35.0937 7.96875 35.75 10.1562 36.2187C10.1562 36.2187 17.5 37.5 20 37.5C22.5 37.5 29.8438 36.2187 29.8438 36.2187C32.0313 35.75 32.3125 35.125 32.3125 33.75C32.2813 30.3437 29.5312 27.5938 26.1562 27.5938Z",
    fill: "url(#paint0_linear_536_2991)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 26.4062C28.4375 23.5 24.3125 22.4688 24.3125 22.4688C11.375 22.4688 28.5938 22.4688 15.6562 22.4688C15.6562 22.4688 11.5312 23.5 10.5 26.4062L13.1562 30.6875L20 29.875L26.1562 30.9375L29.4688 26.4062Z",
    fill: "url(#paint1_linear_536_2991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 23.4688C19.4063 23.4688 20.5625 23.4688 16.75 23.4688C15.4062 24.25 11.2812 28.625 11.2812 28.7812L12.3438 30.9375C35.2813 30.9375 4.75 30.9375 27.6875 30.9375L28.75 28.7812C28.7188 28.625 24.5938 24.25 23.25 23.4688Z",
    fill: "url(#paint2_linear_536_2991)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68763 29.125L10.5314 26.4062C10.5314 26.4062 12.1251 28.5 20.0001 30.9375C18.5626 33.3437 12.4376 32.8438 10.1251 30.7188C9.68763 30.3125 9.50013 29.6875 9.68763 29.125Z",
    fill: "url(#paint3_linear_536_2991)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 29.125L29.4688 26.4062C29.4688 26.4062 27.875 28.5 20 30.9375C21.4375 33.3437 27.5625 32.8438 29.875 30.7188C30.3125 30.3125 30.5 29.6875 30.3125 29.125Z",
    fill: "url(#paint4_linear_536_2991)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 35.4688V31.5C15.5938 31.2813 15.7812 31.0938 16 31.0938C16.2187 31.0938 16.4062 31.2813 16.4062 31.5V35.4688H15.5938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 34.125V35.6563C16.6875 36.0313 16.375 36.3438 16 36.3438C15.625 36.3438 15.3125 36.0313 15.3125 35.6563V34.125H16.6875Z",
    fill: "url(#paint5_linear_536_2991)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4062 35.4688V31.5C24.4062 31.2813 24.2188 31.0938 24 31.0938C23.7813 31.0938 23.5938 31.2813 23.5938 31.5V35.4688H24.4062Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3125 34.125V35.6563C23.3125 36.0313 23.625 36.3438 24 36.3438C24.375 36.3438 24.6875 36.0313 24.6875 35.6563V34.125H23.3125Z",
    fill: "url(#paint6_linear_536_2991)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.2812C20 31.2812 16.3125 29.625 16.3125 27.5938V25.125H23.6875V27.5938C23.6875 29.6563 20 31.2812 20 31.2812Z",
    fill: "url(#paint7_linear_536_2991)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6878 26.5937C36.8128 29.625 35.0003 2.5 20.0003 2.5C5.03156 2.5 3.18781 29.625 16.3128 26.5937H23.6878Z",
    fill: "url(#paint8_radial_536_2991)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5626 14.0938C28.5626 14.0938 23.6563 13.9063 21.0626 11.4375C20.4688 10.875 19.5313 10.875 18.9063 11.4375C16.3126 13.9063 11.4063 14.0938 11.4063 14.0938C8.0938 14.0938 8.0313 19.1563 11.4063 19.2813C11.7188 21.8438 13.2188 27.25 19.9688 27.25C26.7188 27.25 28.2188 21.8438 28.5313 19.2813C31.9376 19.1563 31.8751 14.0938 28.5626 14.0938Z",
    fill: "url(#paint9_radial_536_2991)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 16.9062C16.8121 16.9062 17.3437 16.3746 17.3437 15.7187C17.3437 15.0629 16.8121 14.5312 16.1562 14.5312C15.5004 14.5312 14.9688 15.0629 14.9688 15.7187C14.9688 16.3746 15.5004 16.9062 16.1562 16.9062Z",
    fill: "url(#paint10_linear_536_2991)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 16.9062C24.4996 16.9062 25.0312 16.3746 25.0312 15.7187C25.0312 15.0629 24.4996 14.5312 23.8438 14.5312C23.1879 14.5312 22.6562 15.0629 22.6562 15.7187C22.6562 16.3746 23.1879 16.9062 23.8438 16.9062Z",
    fill: "url(#paint11_linear_536_2991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_2991",
    x1: 20,
    y1: 37.5,
    x2: 20,
    y2: 27.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_2991",
    x1: 20,
    y1: 30.9375,
    x2: 20,
    y2: 22.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_2991",
    x1: 20,
    y1: 30.9375,
    x2: 20,
    y2: 23.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9590AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_536_2991",
    x1: 14.8111,
    y1: 32.5416,
    x2: 14.8111,
    y2: 26.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_536_2991",
    x1: 25.189,
    y1: 32.5416,
    x2: 25.189,
    y2: 26.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_536_2991",
    x1: 15.2764,
    y1: 35.2393,
    x2: 16.6749,
    y2: 35.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9590AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_536_2991",
    x1: 23.318,
    y1: 35.2393,
    x2: 24.7165,
    y2: 35.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9590AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_536_2991",
    x1: 20,
    y1: 31.2927,
    x2: 20,
    y2: 25.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1655,
    stopColor: "#FEB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3534,
    stopColor: "#FCA695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5514,
    stopColor: "#F78F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#F27165"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_536_2991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.89057 5.59244) scale(28.3346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292B2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_536_2991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.11521 10.6795) scale(23.9528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3779,
    stopColor: "#FFB6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5856,
    stopColor: "#FFAE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#FEA090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    stopColor: "#FD8D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_536_2991",
    x1: 14.5481,
    y1: 14.3139,
    x2: 16.6509,
    y2: 16.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_536_2991",
    x1: 22.2875,
    y1: 14.2408,
    x2: 24.3244,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.da6fbb93fe58a59d12b7bb7444fecb8c.svg";
export { ForwardRef as ReactComponent };